import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Grid } from "capitalrx-components-2.0/lib/layout";
import { Paragraph, Subheading } from "capitalrx-components-2.0/lib/typography";

export const CodeSentForm: FC = () => {
  const { t: translate } = useTranslation();
  return (
    <Grid testId="code-sent-container">
      <Grid.Span columns={12}>
        <Subheading textAlign="center">{translate("FORGOT_PASSWORD.codeSentForm.confirmationCodeToEmail")}</Subheading>
      </Grid.Span>

      <Grid.Span columns={12}>
        <Paragraph textAlign="center">{translate("FORGOT_PASSWORD.codeSentForm.clickToResetYourPassword")}</Paragraph>
      </Grid.Span>
    </Grid>
  );
};
